<template>
  <div class="ts-h-full">
    <h3 class="ts-text-xs ts-uppercase ts-text-blue-700">
      {{ $t('productProfile.productPhoto') }}
    </h3>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <ts-image-input
            :file="model.photo ? model.photo : file"
            @input="file => (model.photo = file)"
						:width="410"
						:height="378"
            crop
          ></ts-image-input>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          <label>{{ $t('productProfile.locationStorage') }}</label>
          <div class="ts-flex">
            <input
              type="text"
              class="
                ts-w-full
                ts-border
                ts-border-r-0
                ts-border-gray-300
                ts-px-2
                ts-py-2
                ts-rounded-tl
                ts-rounded-bl
                ts-outline-none
              "
              readonly
              :value="model.warehouse_storage_name"
            />
            <a
              href="#"
              @click.prevent="showList"
              class="ts-bg-gray-200 ts-px-3 ts-py-2 ts-rounded-tr ts-rounded-br"
            >
              <i class="fas fa-map-pin"></i>
            </a>
          </div>
        </div>
      </div>
    </form>
    <a-modal
      v-model="show_list"
      :title="$t('productProfile.locationList')"
      :centered="true"
      :footer="null"
      :z-index="1020"
    >
      <ts-loading-banner :loading="loading">
			<div class="ts-relative">
				<input 
					v-model.trim="search"
					type="text" class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
					:placeholder="$t('productProfile.searchLocation')"
				>
				<span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px"><i class="fa fa-search"></i></span>
			</div>
        <div style="clear:both"></div>
        <div style="height: 50vh" class="ts-overflow-scroll ts-mt-3">
          <a-radio-group
            v-model="model.warehouse_storage_id"
            class="ts-p-3"
            @change="changeLocation"
          >
            <a-radio
              v-for="(locat, index) in location_list"
              :value="locat.warehouse_storage_id"
              :key="index"
              >{{ locat.storage_name_en }}</a-radio
            >
          </a-radio-group>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import TsRadio from '../../../../components/common/TsRadio.vue'
export default {
  components: { TsRadio },
  name: 'photo',
  props: ['value', 'validate'],
  data() {
    return {
      show_list: false,
      loading: false,
      search: null,
      location_list: [],
      errors: new Errors(),
      file: require('@/assets/default-product_flat.jpg'),
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('product/profile', ['getLocationStorage']),
    showList() {
      this.show_list = true
      this.fetchLocation()
    },
    fetchLocation(){
      this.loading = true
      this.getLocationStorage({
        filter: {
          search: this.search
        }
      })
        .then((response) => {
          this.location_list = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeLocation(e) {
      const id = e.target.value
      this.model.warehouse_storage_name = this.location_list.find(
        (l) => l.warehouse_storage_id == id
      ).storage_name_en
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
    search: debounce(function (search) {
      this.fetchLocation()
    }, 500)
  },
}
</script>